import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-card-hover p-8" data-testid="admin-login">
        <div className="text-center mb-8">
          <span className="inline-flex p-3 rounded-xl bg-gold/15 text-gold-dark mb-4"><Lock className="w-6 h-6" /></span>
          <h1 className="font-display text-2xl text-navy">Admin Dashboard</h1>
          <p className="text-sm text-muted-foreground mt-1">Mathura Homes</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email" className="text-xs font-semibold text-navy">Email</Label>
            <Input id="email" data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-gray-50 mt-1" placeholder="admin@mathuradevelopers.com" />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs font-semibold text-navy">Password</Label>
            <Input id="password" data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="bg-gray-50 mt-1" placeholder="••••••••" />
          </div>
          <Button type="submit" disabled={loading} data-testid="admin-login-btn" className="w-full bg-gold text-navy hover:bg-gold-dark font-semibold">
            {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Signing in...</> : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
